import Link from "@mui/material/Link";
import MenuItem, { MenuItemProps } from "@mui/material/MenuItem";
import { ReactNode, forwardRef } from "react";

import MDBox from "@/components/atoms/MDBox";
import MDTypography from "@/components/atoms/MDTypography";
import menuItem from "@/mui/Items/NotificationItem/styles";

interface NotificationProps extends MenuItemProps {
  icon: ReactNode;
  title?: string;
  children?: ReactNode;
}

const NotificationItem = forwardRef<HTMLLIElement, NotificationProps>(
  ({ icon, title, children, ...rest }, ref) => {
    if (children) {
      return (
        <MenuItem {...rest} ref={ref} sx={(theme) => menuItem(theme)}>
          <MDBox component={Link} py={0.5} display="flex" alignItems="center" lineHeight={1}>
            <MDTypography variant="body1" color="secondary" lineHeight={0.75}>
              {icon}
            </MDTypography>
            {children}
          </MDBox>
        </MenuItem>
      );
    } else {
      return (
        <MenuItem {...rest} ref={ref} sx={(theme) => menuItem(theme)}>
          <MDBox component={Link} py={0.5} display="flex" alignItems="center" lineHeight={1}>
            <MDTypography variant="body1" color="secondary" lineHeight={0.75}>
              {icon}
            </MDTypography>
            <MDTypography variant="button" fontWeight="regular" sx={{ ml: 1 }}>
              {title}
            </MDTypography>
          </MDBox>
        </MenuItem>
      );
    }
  }
);

NotificationItem.displayName = "NotificationItem";
export default NotificationItem;
